import React from "react";
import SuspenseComp from "../../components/shared/SuspenseComp";
import { getPathFromRouter, isPME_TEAM } from "../../helper";
import { SkeletonPagePolaris } from "../../components/shared/SkeletonPagePolaris";
import { useAppContext } from "../../context";

const ArtistTaskComp = React.lazy(() =>
    import("../../components/tasks/artist/ArtistTask"),
);

export default function ArtistTaskPage(...props) {
    const path = getPathFromRouter(props);

    const { currentUser } = useAppContext();
    const isPME = isPME_TEAM(currentUser);

    return isPME ? (
        <SuspenseComp fallback={<SkeletonPagePolaris />}>
            <ArtistTaskComp path={path} />
        </SuspenseComp>
    ) : (
        <p>You don't have privilege to accept this page</p>
    );
}
